// Entity model -- class (not an interface)
// Need information at runtime about the entity -- takes care of effort in writing code at runtime
// Interface is a compile time only feature
// Class -- javaScript feature, included in compilation, available at runtime

import { Entity, Key } from '@briebug/ngrx-auto-entity';

@Entity({
  modelName: 'KudosReason',
  uriName: 'kudos-reasons',
})
export class KudosReason {
  @Key userId!: string;
  attitudeAverage!: number | null;
  punctualityAverage!: number | null;
  qualityAverage!: number | null;
  professionalismAverage!: number | null;
  dependabilityAverage!: number | null;
  timelyCommunicationAverage!: number | null;
  likelyToUseAgainAverage!: number | null;
  completedProjectReviews!: number;
}
